var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      Object.keys(_vm.selectedStudent).length > 0
        ? [
            _vm.roleRules.GRADES_FLG === "Y"
              ? _vm._l(_vm.courseList, function(school, schoolIdx) {
                  return _c("section", { key: "school-" + schoolIdx }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-12" }, [
                        _c("h2", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(school.SCHOOL_TITLE) +
                              "\n\t\t\t\t\t\t"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-6 col-lg-4" },
                        [
                          _c("sapphire-toggle", {
                            staticStyle: { "margin-top": "12px" },
                            attrs: {
                              label: _vm.$t(
                                "MAIN_CONTENT.CoursesAndGradesList.showNonHyphenGradeClasses"
                              )
                            },
                            model: {
                              value: _vm.showNonGrade,
                              callback: function($$v) {
                                _vm.showNonGrade = $$v
                              },
                              expression: "showNonGrade"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "table-responsive" },
                      [
                        _c(
                          "table-editable-list",
                          {
                            attrs: {
                              columns: _vm.columns,
                              showColumns: _vm.showHideColumns,
                              "show-select": false,
                              "show-actions": false
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "data-row" },
                              [
                                _vm._l(school.COURSES, function(
                                  course,
                                  courseIdx
                                ) {
                                  return [
                                    !!course.COURSE_SECTION_GUID
                                      ? _c("table-list-row", {
                                          key:
                                            "course-" +
                                            course.COURSE_ID +
                                            "-" +
                                            courseIdx,
                                          attrs: {
                                            columns: _vm.columns,
                                            showColumns: _vm.showHideColumns,
                                            rowdata: course,
                                            rowIndex: courseIdx,
                                            useAnchor: false,
                                            showActions: false
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                })
                              ],
                              2
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ])
                })
              : [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm.$t("MAIN_CONTENT.commonContent.invalidPermissions")
                      ) +
                      "\n\t\t"
                  )
                ]
          ]
        : [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.$t(
                    "MAIN_CONTENT.commonContent.noStudentHasBeenSelectedWithPeriod"
                  )
                ) +
                "\n\t"
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }